import { Table, Tag, Space } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { formatRole, type ZealysLogin } from '../types/internal-access.types'

interface ZealysLoginsTableProps {
  logins: ZealysLogin[]
  loading: boolean
  onRowClick?: (loginId: string) => void
  selectedLoginId?: string | null
}

export function ZealysLoginsTable({ logins, loading, onRowClick, selectedLoginId }: ZealysLoginsTableProps) {
  const columns: ColumnsType<ZealysLogin> = [
    {
      title: 'Login Code',
      dataIndex: 'loginCode',
      key: 'loginCode',
      width: 150,
      sorter: (a, b) => a.loginCode.localeCompare(b.loginCode)
    },
    {
      title: 'Name',
      dataIndex: 'loginName',
      key: 'loginName',
      width: 200,
      sorter: (a, b) => (a.loginName || '').localeCompare(b.loginName || '')
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 250,
      sorter: (a, b) => a.email.localeCompare(b.email)
    },
    {
      title: 'Roles',
      dataIndex: 'roles',
      key: 'roles',
      width: 350,
      sorter: (a, b) => (a.roles?.length || 0) - (b.roles?.length || 0),
      render: (roles: string[]) => (
        <Space size={[4, 4]} wrap>
          {roles && roles.length > 0 ? (
            roles.map(role => {
              let color = 'default'
              if (role === 'System Admin') color = 'red'
              else if (role.includes('admin')) color = 'purple'
              else if (role.includes('approver')) color = 'blue'
              else if (role.includes('requester')) color = 'gold'
              else if (role.includes('user')) color = 'green'

              return (
                <Tag key={role} color={color} style={{ fontSize: '11px', padding: '0 7px', margin: 0 }}>
                  {formatRole(role)}
                </Tag>
              )
            })
          ) : (
            <span style={{ color: '#999', fontSize: '12px' }}>No roles</span>
          )}
        </Space>
      )
    }
  ]

  return (
    <div className="zealys-logins-table-wrapper" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Table
        size="small"
        columns={columns}
        dataSource={logins}
        loading={loading}
        rowKey="id"
        scroll={{ x: 'max-content', y: 'calc(100vh - 200px)' }}
        pagination={false}
        style={{ flex: 1 }}
        onRow={record => ({
          onClick: () => onRowClick?.(record.id),
          className: selectedLoginId === record.id ? 'login-row-selected' : '',
          style: {
            cursor: onRowClick ? 'pointer' : 'default'
          }
        })}
      />
    </div>
  )
}
